import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'

import { Container } from '../components/Container'
import { Section } from '../components/Section'
import { ServicesGrid } from '../components/ServicesGrid'
import { ServicesList } from '../components/ServicesList'
import { Heading } from '../components/Heading'

interface ServicesProps {
  layout?: 'grid' | 'list'
  sectionTitle?: string
  ctaElement?: React.ReactNode
}

export const Services = ({ layout = 'grid', sectionTitle, ctaElement }: ServicesProps) => {
  const { services } = useStaticQuery(graphql`
    query ServiceSection {
      services: allWpService(sort: { menuOrder: ASC }) {
        nodes {
          id
          title
          content
          slug
          excerpt
          service {
            excerptList
          }
          featuredImage {
            node {
              sourceUrl
            }
          }
        }
      }
    }
  `)

  return (
    <Section>
      <Container>
        <div className="grid gap-8 justify-items-start">
          {sectionTitle && <Heading as="h2">{sectionTitle}</Heading>}

          {layout === 'grid' && <ServicesGrid services={services.nodes} />}

          {layout === 'list' && <ServicesList services={services.nodes} />}

          {ctaElement && ctaElement}
        </div>
      </Container>
    </Section>
  )
}
